// DEPENDENCIES
import isObject from 'lodash/isObject';

/**
 * Performs application error handling through toasts
 * @function defaultErrorHandler
 * @param {Object} error - The application error
 * @param {string} content - The content shown on Toast
 * @param {string} type  - The Toast type. Allowed values: info, warning, danger, success
 * @returns {Object} - Returns an object containing the parameters used by the toast
 * @example
 * // Renders a toast with default parameters
 * this.$refs.TOAST_REF.createToast(defaultErrorHandler());
 */

export function defaultErrorHandler(
	error,
	content = `
    <h3 class="title">Por favor, tente novamente</h3>
    <p class="subtitle">
      Encontramos um erro inesperado.
      Pedimos que tente mais uma vez.
    </p>
  `,
	type = 'danger'
) {
	const defaultMessage = {
		content,
		type
	};

	if (!isObject(error) || (isObject(error) && !error.response)) {
		return defaultMessage;
	}

	const statusMessage = {
		401: {
      content: `
        <h3 class="title">Sua sessão expirou</h3>
        <p class="subtitle">Tente <a href='/login'>fazer login novamente</a>.</p>
      `,
			type: 'danger'
		},
		403: {
      content: `
        <h3 class="title">Não é possível continuar :/</h3>
        <p class="subtitle">Parece que você não tem permissão para acessar o recurso.</p>
      `,
			type: 'danger'
		},
		429: {
      content: `
        <h3 class="title">Tente novamente mais tarde</h3>
        <p class="subtitle">
          Encontramos um erro e não conseguimos processar sua solicitação.
          Aguarde alguns instantes e tente mais uma vez.
        </p>
      `,
			type: 'danger'
		},
		500: {
      content: `
        <h3 class="title">Por favor, tente novamente</h3>
        <p class="subtitle">
          Encontramos um erro inesperado.
          Pedimos que tente mais uma vez.
        </p>
      `,
			type: 'danger'
		}
	}[String(error.response.status)];

	return statusMessage || defaultMessage;
}
